// helpers/extensionScrape.js

const makeReqId = () =>
    (typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : (Date.now() + "-" + Math.random()));

export function fetchReviewDataFromExtension(inputUrl, { timeoutMs = 15000 } = {}) {
    return new Promise((resolve, reject) => {
        const requestId = makeReqId();
        let timeoutId;

        const onMsg = (e) => {
            const m = e.data;
            if (!m || m.type !== "VIRT_SCRAPE_DONE" || m.requestId !== requestId) return;
            cleanup();
            if (m.ok && m.data) {
                resolve(m.data); // структура: как у твоего метода: { review_link, asin, review_name, ... }
            } else {
                reject(m.error || "Extension returned an error");
            }
        };

        const cleanup = () => {
            window.removeEventListener("message", onMsg);
            if (timeoutId) clearTimeout(timeoutId);
        };

        window.addEventListener("message", onMsg);

        // Таймаут на случай отсутствия расширения/моста/любой заминочки
        timeoutId = setTimeout(() => {
            cleanup();
            reject("Extension not available or timed out");
        }, timeoutMs);

        // Команда мосту site_bridge.js (контент-скрипт расширения на твоём домене)
        window.postMessage(
            { type: "VIRT_SCRAPE_START", url: inputUrl, requestId },
            "*"
        );
    });
}
